/** Kleinbuchstaben, trim, Mehrfach-Leerzeichen → ein Leerzeichen */
export function normalizePersonName(s) {
  return (s || '')
    .toLowerCase()
    .trim()
    .replace(/\s+/g, ' ');
}

export function emailDomain(email) {
  if (!email || typeof email !== 'string' || !email.includes('@')) return '';
  const p = email.trim().toLowerCase().split('@');
  return (p[1] || '').trim();
}

export function normalizePhoneLoose(raw) {
  if (!raw) return '';
  return String(raw).replace(/\s/g, '');
}

/**
 * Duplikate zum manuellen Anlegen: gleiche E-Mail, gleiches Telefon,
 * oder gleicher Name + gleiche E-Mail-Domain (bzw. Lead-Domain).
 */
export function findDuplicateLeads(leads, { name, email, tel, domain }) {
  const nm = normalizePersonName(name);
  const em = (email || '').trim().toLowerCase();
  const dom = (domain || '').trim().toLowerCase() || emailDomain(em);
  const telN = normalizePhoneLoose(tel);
  return leads.filter((l) => {
    if (em && l.email && String(l.email).trim().toLowerCase() === em) return true;
    if (telN && l.tel && normalizePhoneLoose(l.tel) === telN) return true;
    if (nm && dom) {
      const lDom = (l.domain || '').trim().toLowerCase() || emailDomain(l.email);
      if (lDom && normalizePersonName(l.name) === nm && lDom === dom) return true;
    }
    return false;
  });
}
